import styles from "./Projects.module.scss";
import Project_img_1 from "../../assets/images/projects/project_1.avif";
import Project_img_2 from "../../assets/images/projects/project_2.avif";
import Project_img_3 from "../../assets/images/projects/project_3.avif";
import Project_img_4 from "../../assets/images/projects/project_4.avif";
import Project_img_5 from "../../assets/images/projects/project_5.avif";
import Project_img_6 from "../../assets/images/projects/project_6.avif";
import Project_img_7 from "../../assets/images/projects/project_7.avif";
import Arrow from "../../assets/images/projects/arrow.svg";

export const Projects = () => {
  const {
    section__projects,
    wrapper__projects,
    projects__title,
    projects__list,
    projects__item,
    projects__name,
    projects__image,
    projects__button,
  } = styles;

  return (
    <section className={section__projects} id="projects">
      <div className={wrapper__projects}>
        <h2
          className={projects__title}
          data-aos="fade-left"
          data-aos-delay="200"
        >
          Wybrane projekty
        </h2>
        <ul className={projects__list}>
          <li
            className={projects__item}
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <p className={projects__name}>Kegel Zone</p>
            <div className={projects__image}>
              <img src={Project_img_7} alt="Project_7" />
            </div>
            <button className={projects__button}>
              <img src={Arrow} alt="arrow" />
              <span>
                <a
                  href="https://kegelzone.netlify.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Otwórz
                </a>
              </span>
            </button>
          </li>

          <li
            className={projects__item}
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <p className={projects__name}>Garden Forum</p>
            <div className={projects__image}>
              <img src={Project_img_5} alt="Project_5" />
            </div>
            <button className={projects__button}>
              <img src={Arrow} alt="arrow" />
              <span>
                <a
                  href="https://garden-forum.netlify.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Otwórz
                </a>
              </span>
            </button>
          </li>

          <li
            className={projects__item}
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <p className={projects__name}>WebStudio</p>
            <div className={projects__image}>
              <img src={Project_img_1} alt="Project_1" />
            </div>
            <button className={projects__button}>
              <img src={Arrow} alt="arrow" />
              <span>
                <a
                  href="https://marcinmierzejewski.github.io/goit-markup-hw-08/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Otwórz
                </a>
              </span>
            </button>
          </li>

          <li
            className={projects__item}
            data-aos="fade-up"
            data-aos-delay="350"
          >
            <p className={projects__name}>BarberShop</p>
            <div className={projects__image}>
              <img src={Project_img_2} alt="Project_2" />
            </div>
            <button className={projects__button}>
              <img src={Arrow} alt="arrow" />
              <span>
                <a
                  href="https://marcinmierzejewski.github.io/barbershop/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Otwórz
                </a>
              </span>
            </button>
          </li>

          <li
            className={projects__item}
            data-aos="fade-up"
            data-aos-delay="400"
          >
            <p className={projects__name}>Portfolio</p>
            <div className={projects__image}>
              <img src={Project_img_6} alt="Project_6" />
            </div>
            <button className={projects__button}>
              <img src={Arrow} alt="arrow" />
              <span>
                <a
                  href="https://marcinmierzejewski.netlify.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Otwórz
                </a>
              </span>
            </button>
          </li>

          <li
            className={projects__item}
            data-aos="fade-up"
            data-aos-delay="500"
          >
            <p className={projects__name}>IceCream</p>
            <div className={projects__image}>
              <img src={Project_img_3} alt="Project_3" />
            </div>
            <button className={projects__button}>
              <img src={Arrow} alt="arrow" />
              <span>
                <a
                  href="https://marcinmierzejewski.github.io/team-project-goit/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Otwórz
                </a>
              </span>
            </button>
          </li>

          <li
            className={projects__item}
            data-aos="fade-up"
            data-aos-delay="650"
          >
            <p className={projects__name}>HellEN</p>
            <div className={projects__image}>
              <img src={Project_img_4} alt="Project_4" />
            </div>
            <button className={projects__button}>
              <img src={Arrow} alt="arrow" />
              <span>
                <a
                  href="https://marcinmierzejewski.github.io/hell/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Otwórz
                </a>
              </span>
            </button>
          </li>
        </ul>
      </div>
    </section>
  );
};
